import { put } from "redux-saga/effects";

import * as actions from "../actions";
import { handleApiError } from '../../utils/apiErrorHandler';

const getCurrentPosition = () => {
    return new Promise((res, rej) => {
        navigator.geolocation.getCurrentPosition(res, rej);
    });
}

export function* setCurrentLocationSaga(action) {
    try {
        if (navigator.geolocation) {
            let position = yield getCurrentPosition();
            var response = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            yield put(actions.setCenter(response));
        } else {
            console.log("navigator.geolocation not supported");
        }
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
    }
}